const sidebar = document.getElementById('sidebar');
const content = document.getElementById('content');

if (sidebar) {
    const contentSections = Array.from(content.children);
    const sidebarItems = Array.from(sidebar.children);

    Array.from(sidebar.children).forEach(function(li) {
        li.addEventListener('click', () => toggle(li));
    });

    const removeActives = () => {
        sidebarItems.forEach((li) => li.classList.remove('active'));
        contentSections.forEach((li) => li.classList.remove('active'));
    };

    const toggle = (sidebar) => {
        removeActives();
        sidebar.classList.add('active');
        contentSections[sidebar.dataset.index].classList.add('active');
    };
}
